import * as ActionType from './Action'


const getTheme =()=>{
     let  temp = window.localStorage.getItem("theme");
     if(!temp)
          temp = "light";
     return temp;
}

const initState = {'language' : 'eng','currency':'usd','theme':getTheme()}

const reducer = (state,action) =>{   

    switch(action.type){
        case ActionType.CHANGE_LANGUAGE:
             return {...state,'language':action.language};
        case ActionType.CHANGE_CURRENCY:
             return {...state,'currency':action.currency};
        case ActionType.CHANGE_THEME:
             return {...state,'theme':action.theme}
        default :
            return state;
    }

}

export default reducer;
export {initState};